import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import Hero from "../components/Hero"
import Logo from "../components/Logo"
import Post from "../components/Post"
import sponsorLogo from "../images/logo-dove.svg"
import { StyledPosts, StyledSection, StyledPostBlockTitle, StyledGuide, StyledVideos } from '../components/Post/style.css'
import Image from "../components/Image"
import VideoPlayer from "../components/VideoPlayer"

class IndexPage extends React.Component {
  render() {
    return (
      <Layout sponsorLogo={sponsorLogo}>
        <Seo title="Amor Propio" />
        <Hero imgfilename="main.jpg">
          <Logo width="200" height="300" />
        </Hero>
        <StyledSection bgColor="#aed0d9" href="http://www.paula.cl/reportajes-y-entrevistas/me-quiero-mucho-poquito-nada/" target="_blank" rel="noopener noreferrer">
          <div className="wrap">
            <div className="col1">
              <Image filename="illustracion-amor-propio.jpg" />
            </div>
            <div className="col2">
              <h2 className="title">¿Me quiero mucho, poquito o nada?</h2>
              <p className="excerpt">De un total de más de tres mil personas encuestadas, un 86% de las mujeres asegura haber dejado de hacer alguna actividad por su apariencia física, un 72% dice sentir vergüenza de su cuerpo y un 30% no se siente conforme consigo misma. Estos son los alarmantes resultados que arrojó el estudio realizado por el colectivo social La Rebelión del Cuerpo. Aunque el ‘amor propio’ parece ser un concepto común, practicarlo pareciera no ser tan simple. Aquí, cinco expertos cuentan en qué consiste, cómo se trabaja y por qué es tan importante.</p>
            </div>
          </div>
        </StyledSection>
        <StyledPosts>
            <StyledPostBlockTitle>
              <div className="wrap">
                <h1>#muéstranos</h1>
                <p>15 historias sobre el amor propio, la autoaceptación y el quererse uno mismo.</p>
              </div>
            </StyledPostBlockTitle>
        {this.props.data.allWordpressPost.edges.map(({ node }) =>
          (
            <Post key={node.id} post={node} />
          ))
        }
        </StyledPosts>
        <StyledGuide>
          <StyledPostBlockTitle>
            <div className="wrap">
              <h1>Guía del Amor Propio</h1>
              <p>Una guía de 10 ilustraciones para conseguir .</p>
            </div>
          </StyledPostBlockTitle>
          <div className="guideBlock">
            <Image filename="1a.jpg" />
          </div>
          <div className="guideBlock">
            <Image filename="1b.jpg" />
          </div>
          <div className="guideBlock">
            <Image filename="2a.jpg" />
          </div>
          <div className="guideBlock">
            <Image filename="2b.jpg" />
          </div>
          <div className="guideBlock">
            <Image filename="3a.jpg" />
          </div>
          <div className="guideBlock">
            <Image filename="3b.jpg" />
          </div>
          <div className="guideBlock">
            <Image filename="4a.jpg" />
          </div>
          <div className="guideBlock">
            <Image filename="4b.jpg" />
          </div>
          <div className="guideBlock">
            <Image filename="5a.jpg" />
          </div>
          <div className="guideBlock">
            <Image filename="5b.jpg" />
          </div>
          <StyledPostBlockTitle>
            <div className="wrap">
              <p>No es tan difícil, ¿o no?</p>
            </div>
          </StyledPostBlockTitle>
        </StyledGuide>
        <StyledVideos>
          <VideoPlayer url="https://unlimited1-cl.dps.live/vod/cl2/latercera/424577/smil:bHoGcr.smil/playlist.m3u8" />
        </StyledVideos>
        <StyledSection bgColor="#eeeeee" titleColor="black" href="http://www.paula.cl/reportajes-y-entrevistas/la-belleza-la-vejez/" target="_blank" rel="noopener noreferrer">
          <div className="wrap">
            <div className="col1">
              <Image filename="ladies.jpg" />
            </div>
            <div className="col2">
              <h2 className="title">La belleza de la vejez</h2>
              <p className="excerpt">A lo largo de sus años, estas tres mujeres han enfrentado un desafío similar: equilibrar sus vidas creativas con sus trabajos y mantenerse fieles a sí mismas. Las tres eligieron áreas competitivas y desafiantes en las que han destacado y, sin embargo, sus ideas de amor propio las han llevado a no compararse con las demás y a celebrar lo que las hace únicas. ¿Qué es envejecer y qué es la vanidad para ellas? ¿Qué entienden por amor propio? Aunque todas se cuidan para verse bien, ni una sigue una dieta estricta ni una rutina fija de belleza. Lo de ellas se trata que aceptar quienes son y aprender a quererse.</p>
            </div>
          </div>
        </StyledSection>
        <StyledVideos>
          <VideoPlayer url="https://unlimited5-cl.dps.live/vod/cl2/latercera/424578/smil:bHoGcC.smil/playlist.m3u8" />
        </StyledVideos>
      </Layout>
    )
  }
}

export const pageQuery = graphql`
  query getByTag($tagslug: String = "especial-amor-propio") {
    allWordpressPost(
      filter: {
        tags: {
          elemMatch: {
            slug: {
              eq: $tagslug
            }
          }
        }
      },
      sort: {
        fields: date
        order: ASC
      }
    ) {
      edges {
        node {
          id
          ...PostContent
        }
      }
    }
  }
`

export default IndexPage
